import { useIdentidades } from '../lib/identidadArticulos';

/** A stored SKU as users see it: its code, plus the supplier when another article has the same code. */
export function CodigoArticulo({ sku }: { sku: string }) {
  const identidad = useIdentidades([sku])(sku);
  if (!identidad) return <span className="font-mono">{sku}</span>;
  return (
    <span>
      <span className="font-mono">{identidad.codigo}</span>
      {identidad.repetido && ` · ${identidad.proveedor?.nombre ?? 'sin proveedor'}`}
    </span>
  );
}

/** Note under a picker: the identity supplier of the picked article. */
export function ProveedorElegido({ proveedor }: { proveedor?: { nombre: string } | null }) {
  if (!proveedor) return null;
  return <p className="mt-0.5 text-xs text-slate-500">Proveedor: {proveedor.nombre}</p>;
}
